import React from 'react';
import { formatDate } from '../../../utils/format_date';

const ViewBillInvoiceModal = ({ showIfDetails, setShowModal }) => {
    if (!showIfDetails) return null;

    const formatCurrency = (amount, currency) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency || 'USD',
        }).format(amount);
    };

    const isAnnually = showIfDetails.validity_type === 'annually';
    let subtotal, discountAmount;

    if (isAnnually) {
        subtotal = showIfDetails.plans.price * 12;
        discountAmount = (subtotal * showIfDetails.plans.discount) / 100;
    }

    return (
        <div className="modal fade show" style={modalStyle}>
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content" style={modalContentStyle}>
                    <div className="card invoice-preview-card p-8">
                        {/* Header */}
                        <div className="w-full d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(null)}
                                aria-label="Close"
                            ></button>
                        </div>

                        {/* Invoice Header */}
                        <div className="card-body invoice-preview-header rounded-4 p-6">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <img src="/assets/img/logo.png" alt="Company Logo" />
                                </div>
                                <div>
                                    <h5>Invoice #{showIfDetails.id}</h5>
                                    <div className="mb-1">
                                        <span>Date Issued: {formatDate(showIfDetails.created_at)}</span>
                                    </div>
                                    <div>
                                        <span>End Date: {formatDate(showIfDetails.end_date)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bill Details */}
                        <div className="card-body py-6 px-0">
                            <div className="d-flex justify-content-between flex-wrap">
                                {/* Invoice Information */}
                                <div>
                                    <h6>Invoice To:</h6>
                                    <p className="mb-1 text-capitalize">
                                        {showIfDetails.user.first_name} {showIfDetails.user.last_name}
                                    </p>
                                    <p className="mb-1">{showIfDetails.user.email}</p>
                                    <p className="mb-1">{showIfDetails.user.phone_no}</p>
                                    <table>
                                        <tbody>
                                            {/* Subtotal, Discount, and Total */}
                                            <tr>
                                                <td className="pe-0 pt-6 w-px-100">
                                                    {isAnnually && <p className="mb-1">Subtotal:</p>}
                                                    {isAnnually && <p className="mb-1 w-100">Disc. ({showIfDetails.plans.discount}%):</p>}
                                                    <p className="mb-0 pt-2">Total:</p>
                                                </td>
                                                <td className="px-0 pt-6 w-px-100">
                                                    {isAnnually && (
                                                        <p className="fw-medium mb-1">
                                                            {formatCurrency(subtotal, showIfDetails.currency)}
                                                        </p>
                                                    )}
                                                    {isAnnually && (
                                                        <p className="fw-medium mb-1">
                                                            {formatCurrency(discountAmount, showIfDetails.currency)}
                                                        </p>
                                                    )}
                                                    <p className="fw-medium mb-0 pt-2">
                                                        {formatCurrency(showIfDetails.amount, showIfDetails.currency)}
                                                    </p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Bill Details Table */}
                                <div className="w-50">
                                    <h6>Bill Details:</h6>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="pe-4">Total Due:</td>
                                                <td>{formatCurrency(showIfDetails.amount, showIfDetails.currency)}</td>
                                            </tr>
                                            <tr>
                                                <td className="pe-4">Plan Name:</td>
                                                <td>{showIfDetails.plan_name}</td>
                                            </tr>
                                            <tr>
                                                <td className="pe-4">Duration:</td>
                                                <td>{isAnnually ? "Annually" : "Monthly"}</td>
                                            </tr>
                                            <tr>
                                                <td className="pe-4">Status:</td>
                                                <td className="text-capitalize">{showIfDetails.status}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        {/* Pricing Breakdown */}
                        <div className="table-responsive">
                            <table className="table m-0 table-borderless">
                                <tbody>
                                    <tr>
                                        <td className="align-top px-0 py-3">
                                            <p className="me-2 fw-medium text-heading">Frequencies Included:</p>
                                            {showIfDetails.user_frequency[0].frequencies.map((freq, index) => (
                                                <span key={freq.id}>
                                                    {freq.category.name}
                                                    {index < showIfDetails.user_frequency[0].frequencies.length - 1 && ', '}
                                                </span>
                                            ))}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <hr />

                        <div className="card-body p-0 mt-2">
                            <span className="fw-medium text-heading">Plan Description: </span>
                            <span>{showIfDetails.plans.description}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const modalStyle = {
    display: 'block',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1050,
};

const modalContentStyle = {
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    position: 'relative',
};

export default ViewBillInvoiceModal;